// アクション一覧
export const actions = {
  // メッセージ
  SET_MESSAGE: 'SET_MESSAGE',                       // グローバルメッセージセット
  ADD_MESSAGE: 'ADD_MESSAGE',                       // グローバルメッセージ追加
  CLEAR_MESSAGE: 'CLEAR_MESSAGE',                   // グローバルメッセージクリアー
  // パンくずリスト
  SET_BREADCRUMB: 'SET_BREADCRUMB',                 // パンくずリスト変数セット
  CLEAR_BREADCRUMB: 'CLEAR_BREADCRUMB',             // パンくずリスト変数クリアー
  // ローディング
  SET_BUTTON_LOADING: 'SET_BUTTON_LOADING',         // ボタンローディングスタート
  CLEAR_BUTTON_LOADING: 'CLEAR_BUTTON_LOADING',     // ボタンローディング終了
  SET_UNIT_LOADING: 'SET_UNIT_LOADING',             // ユニットローディングスタート
  CLEAR_UNIT_LOADING: 'CLEAR_UNIT_LOADING',         // ユニットローディング終了
  SET_PAGE_LOADING: 'SET_PAGE_LOADING',             // 画面ローディングスタート
  CLEAR_PAGE_LOADING: 'CLEAR_PAGE_LOADING',         // 画面ローディング終了
  SET_OVERLAY: 'SET_OVERLAY',                       // オーバーレイ表示
  CLEAR_OVERLAY: 'CLEAR_OVERLAY',                   // オーバーレイ非表示
  // ヘッダー
  SET_HEADER: 'SET_HEADER',                         // ヘッダーセット
  CLEAR_HEADER: 'CLEAR_HEADER',                     // ヘッダークリアー
  // ページデータ
  SET_PAGEDATA: 'SET_PAGEDATA',                     // アプリケーション内保持ページデータ
  // 管理者アカウント
  REGIST_ACCOUNT: 'REGIST_ACCOUNT',                               // 管理者アカウント登録
  UPDATE_ACCOUNT: 'UPDATE_ACCOUNT',                               // 管理者アカウント編集
  DELETE_ACCOUNT: 'DELETE_ACCOUNT',                               // 管理者アカウント削除
  FETCH_ACCOUNT: 'FETCH_ACCOUNT',                                 // 管理者アカウント取得
  FETCH_ACCOUNTS: 'FETCH_ACCOUNTS',                               // 管理者アカウントリスト取得
  TOGGLE_ACCOUNT_ENABLE_DISABLE: 'TOGGLE_ACCOUNT_ENABLE_DISABLE', // 管理者アカウント有効・無効
  // プログラムファイル
  UPLOAD_PROGRAM_FILE: 'UPLOAD_PROGRAM_FILE',       // プログラムファイルアップロード
  DELETE_PROGRAM_FILE: 'DELETE_PROGRAM_FILE',       // プログラムファイル削除
  FETCH_PROGRAM_FILES: 'FETCH_PROGRAM_FILES',       // プログラムファイル取得
  // 調整プログラム設定
  REGIST_PROGRAM_SETTING: 'REGIST_PROGRAM_SETTING', // 調整プログラム設定登録
  UPDATE_PROGRAM_SETTING: 'UPDATE_PROGRAM_SETTING', // 調整プログラム設定編集
  DELETE_PROGRAM_SETTING: 'DELETE_PROGRAM_SETTING', // 調整プログラム設定削除
  FETCH_PROGRAM_SETTING: 'FETCH_PROGRAM_SETTING',   // 調整プログラム設定取得
  FETCH_PROGRAM_SETTINGS: 'FETCH_PROGRAM_SETTINGS', // 調整プログラム設定リスト取得
  // 進捗率  
  SET_PROGRESSRATE: 'SET_PROGRESSRATE',
  CLEAR_PROGRESSRATE: 'CLEAR_PROGRESSRATE',
};

export const response = {
  status: 200,
  count: 0,
  errcode: '',
  msg: '',
};